import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableSettingsCell = (props: TableSimpleCellProps<ScanRunsListItem>) => (
  <TableSimpleCell {...props} />
);

export default ScanRunsTableSettingsCell;
